<template>
  <div class="w-100 pa-2">
    <v-select name="fieldType" v-model="selectedField" :items="filteredFields" item-value="value" group-by="category"
      variant="solo" density="compact" placeholder="Selecteer een veldtype" required class="custom-field-selected-item"
      menu-icon="fal fa-chevron-down" :menu-props="{ class: 'kyano-menu' }">
      <!-- Zoekbalk -->
      <template #prepend-item>
        <v-list-item>
          <v-text-field v-model="search" placeholder="Zoek veld…" variant="solo" density="compact" clearable />
        </v-list-item>
        <v-divider />
      </template>

      <!-- Groepskop per categorie -->
      <template #groupHeader="{ group }">
        <v-list-item>
          <v-list-item-title class="subtitle-2 font-weight-bold">
            {{ group }}
          </v-list-item-title>
        </v-list-item>
      </template>

      <!-- Custom item slot -->
      <template #item="{ props, item }">
        <v-list-item v-bind="props" class="custom-field-selected-item">
          <template #prepend>
            <div class="icon-custom-field" v-html="icons('field-' + item.value)" />
          </template>
        </v-list-item>
      </template>

      <!-- Custom selectie slot -->
      <template #selection="{ item, props }">
        <v-list-item v-bind="props" class="custom-field-selected-item">
          <template #prepend>
            <div class="icon-custom-field" v-html="icons('field-' + item.value)" />
          </template>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-select>
  </div>
</template>

<script>
import cf from "@/util/Customfields";
import { icons } from "@/util/Icons";

export default {
  name: "FieldTypes",
  props: {
    modelValue: String,
  },
  emits: ["update:modelValue"],
  data() {
    return {
      fieldTypes: cf.customFieldsList(), // verwacht: [{ value: "basic", fields:[{ value, title }, …] }, …]
      search: "",
      selectedField: null,
    };
  },
  computed: {
    // flatten + voeg juiste category-label toe
    allFields() {
      return this.fieldTypes.flatMap((group) => {
        // maak “Basic” etc. mooi hoofdletter
        const label = group.value.charAt(0).toUpperCase() + group.value.slice(1);
        return group.fields.map((f) => ({
          ...f,
          category: label,
        }));
      });
    },
    // filter op zoekterm
    filteredFields() {
      if (!this.search) return this.allFields;
      const term = this.search.toLowerCase();
      return this.allFields.filter((f) => f.title.toLowerCase().includes(term));
    },
  },
  watch: {
    // emit bij verandering
    selectedField(val) {
      this.$emit("update:modelValue", val);
    },
    // iniële sync
    modelValue: {
      immediate: true,
      handler(val) {
        this.selectedField = val;
      },
    },
  },
  methods: {
    icons,
  },
};
</script>
<style>
.icon-custom-field svg {
  width: 18px;
  margin-bottom: 0px;
}

.custom-field-selected-item.v-select {
  padding: 0px !important;
  height: unset !important;
  min-height: unset !important;
}

.custom-field-selected-item {
  height: unset !important;
  min-height: unset !important;

  .v-list-item {
    padding: 0px !important;

    .icon-custom-field {
      background: #24a1c740;
      width: 25px !important;
      min-width: 25px;
      height: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 5px;
    }

    svg {
      /* --bg-color: #24a1c7; */
      margin: 0px !important;
      color: #24a1c7;
    }
  }

  .v-list-item__prepend {
    display: flex !important;
    align-items: center !important;
    width: 30px;
  }
}

.dropdown-items-repeater {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;

  .item-repeater {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    margin-bottom: 8px;
  }
}
</style>
